export const RefValue = ({ value, record }) => (Math.round(record.result?.refValue*100)/100).toFixed(2)
